import React, {FC} from 'react';
import style from './style.module.scss';
import {Typography} from 'components/Typography';

interface IProps {
    title: string;
    url: string;
    imageUrl: string | null;
}

const ProductGiftBanner: FC<IProps> = ({title, url, imageUrl}) => (
    <div className={style.giftBanner}>
        <Typography className={style.giftBannerTitle} element={'div'} variant={'title-18-m'}>
            {title}
        </Typography>
        {/* ВНИМАНИЕ! Не использовать Link, т.к. не все страницы еще готовы на новом фронте */}
        <a className={style.giftBannerButton} href={url}>
            <Typography element={'span'} variant={'label-12-m'}>
                Все товары акции
            </Typography>
        </a>
        {imageUrl && (
            <div className={style.giftBannerImageBlock}>
                <div className={style.giftBannerCircle} />
                <img alt={title} className={style.giftBannerImage} src={imageUrl} />
            </div>
        )}
    </div>
);

export default ProductGiftBanner;
